import React from "react";

// SVG flag via flag-icons (CSS background), indexed by ISO alpha-2 code.
// Renders on all platforms (unlike emoji flags on Windows/Chrome).
export const Flag = ({ code, className = "" }) => {
  if (!code) return null;
  return (
    <span
      className={`fi fi-${code.toLowerCase()} inline-block shrink-0 rounded-[2px] shadow-sm ${className}`}
      style={{ width: "1.35em", height: "1em", backgroundSize: "cover" }}
      aria-hidden="true"
    />
  );
};
